import React, { useEffect } from 'react'

export const useVisibleForSomeTime = ({
  element,
  minTime,
  onVisible,
  isPageVisible,
}: {
  element: React.RefObject<HTMLElement | null>
  minTime: number
  onVisible: () => void
  isPageVisible: boolean
}) => {
  useEffect(() => {
    if (!isPageVisible) {
      return
    }
    const ref = element.current
    let visibilityTimeout: undefined | ReturnType<typeof setTimeout> = undefined
    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries
        if (entry?.isIntersecting && visibilityTimeout === undefined) {
          visibilityTimeout = setTimeout(() => {
            onVisible()
            visibilityTimeout = undefined
          }, minTime)
        } else if (entry?.isIntersecting === false && visibilityTimeout !== undefined) {
          clearTimeout(visibilityTimeout)
          visibilityTimeout = undefined
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      }
    )
    if (ref) {
      observer.observe(ref)
    }

    return () => {
      if (ref) {
        observer.unobserve(ref)
      }
      if (visibilityTimeout !== undefined) {
        clearTimeout(visibilityTimeout)
      }
    }
  }, [element, onVisible, minTime, isPageVisible])
}
